export default __webpack_public_path__ + "static/media/mauricio-teaching.283ec194.jpeg";